export enum VideoPlayerEventEnum {
    READY = 'ready',
    LOAD_START = 'load-start',
    LOADED = 'loaded',
    PROGRESS = 'progress',
    PLAY = 'play',
    PAUSE = 'pause',
    ENDED = 'ended',
    ERROR = 'error',
    VOLUME_CHANGE = 'volume-change',
    FULLSCREEN_CHANGE = 'fullscreen-change',
    SEEK_START = 'seek-start',
    SEEK_END = 'seek-end',
    SCRUB_START = 'scrub-start',
    SCRUB_END = 'scrub-end',
}

export const VideoJSEventEnum = {
    READY: 'ready',
    PLAY: 'play',
    PAUSE: 'pause',
    ENDED: 'ended',
    TIME_UPDATE: 'timeupdate',
    SEEKING: 'seeking',
    SEEKED: 'seeked',
    VOLUME_CHANGE: 'volumechange',
    MUTE: 'mute',
    UNMUTE: 'unmute',
    FULLSCREEN_CHANGE: 'fullscreenchange',
    RESIZE: 'resize',
    ERROR: 'error',
    LOADED_METADATA: 'loadedmetadata',
    LOADED_DATA: 'loadeddata',
    LOADED_START: 'loadstart',
    DURATION_CHANGE: 'durationchange',
    RATE_CHANGE: 'ratechange',
    WAITING: 'waiting',
    CAN_PLAY: 'canplay',
    CAN_PLAY_THROUGH: 'canplaythrough',
    KEYDOWN: 'keydown',
    ENTER_PIP: 'enterpictureinpicture',
    LEAVE_PIP: 'leavepictureinpicture',
};
